module.exports = __webpack_public_path__ + "images/emoji/mag_right.5ca395190f1afba5aab8.png";